import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import NoDataFound from "../collections/k-8/components/shared/NoDataFound";
import { COLLECTION_NAME } from "../collections/shared/common";
import axios from "../axios";
import { toast } from "react-toastify";
import { login } from "../slices/userSlice";

function CollectionScreen() {
  const naviagte = useNavigate();
  const location = useLocation();
  const { user, is_authenticated } = useSelector((state) => state.user);
  const params = new URLSearchParams(location.search);
  const [sessionOtp, setSessionOtp] = useState(params.get("otp") || null);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!is_authenticated) {
      naviagte("/");
    }
    if (sessionOtp && !user?.collections && is_authenticated) {
      axios
        .get(`/auth/login/sso/user?otp=${sessionOtp}`, {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((res) => {
          //enter data in local storage and display collections

          const userData = res.data.data;
          let obj = {
            id: userData._id,
            name: userData.name,
            email: userData.email,
            collections: userData.collections,
          };

          dispatch(
            login({
              user: obj,
              access_token: userData.access_token,
              has_name: userData.profileCompletion.name,
              is_authenticated: true,
            })
          );
          setSessionOtp(null);
        })
        .catch((err) => {
          // console.log(err);
          let data = err.response?.data;
          // (data);
          if (!data?.success) {
            toast.error("Error: " + (data?.error?.message || "Something went wrong"));
          }
        });
    }
    if (
      user?.collections?.filter((obj) => obj.tag !== COLLECTION_NAME.CP)
        .length === 1
    ) {
      user?.collections?.forEach(({ tag }) => {
        if (tag !== COLLECTION_NAME.CP) {
          if (tag === COLLECTION_NAME.K8) {
            naviagte(`/${tag}/user-management`);
          } else if (tag === COLLECTION_NAME.SEO) {
            naviagte(`/${tag}/dashboard/analytics`);
          } else if (tag === COLLECTION_NAME.BAU) {
            naviagte(`/${tag}/dashboard/data-management`);
          } else if (tag === COLLECTION_NAME.DESR) {
            naviagte(`/${tag}/design-requisition/user-management/policy-management`);
          } else {
            naviagte(`/${tag}/dashboard`);
          }
        }
      });
    }
  }, [user, sessionOtp]);

  return (
    <div className="flex items-center gap-10 justify-center w-full flex-wrap h-[calc(100vh-75px)] absolute top-[75px]">
      {user?.collections?.length === 0 ? (
        <div>
          <NoDataFound
            message={
              "You are not a part of any Collection. Please ask your manager to assign policies to you."
            }
          />
        </div>
      ) : (
        user?.collections
          ?.filter((obj) => obj.tag !== COLLECTION_NAME.CP)
          .map((obj) => (
            <div
              key={obj._id}
              onClick={() => {
                if (obj.tag === COLLECTION_NAME.K8) {
                  naviagte(`/${obj.tag}/user-management`);
                } else if (obj.tag === COLLECTION_NAME.SEO) {
                  naviagte(`/${obj.tag}/dashboard/analytics`);
                } else if (obj.tag === COLLECTION_NAME.BAU) {
                  naviagte(`/${obj.tag}/dashboard/data-management`);
                } else if (obj.tag === COLLECTION_NAME.DESR) {
                  naviagte(`/${obj.tag}/design-requisition/user-management/policy-management`);
                } else {
                  naviagte(`/${obj.tag}/dashboard`);
                }
              }}
              className="h-48 relative w-48 bg-white shadow-lg flex cursor-pointer border-gray-100 border hover:border-gray-200"
            >
              <div className="whitespace-nowrap absolute top-4 left-2.5 text-xl text-primary font-bold underline">
                <h4 className="">{obj.name}</h4>
              </div>
              <div className="w-full h-full">
                <img
                  style={{
                    borderTopLeftRadius: "100%",
                    borderTopRightRadius: "0%",
                  }}
                  src="/Images/loginImage2.jpg"
                  className="rounded-t-[20%] w-full h-full object-cover"
                  alt=""
                />
              </div>
            </div>
          ))
      )}
    </div>
  );
}

export default CollectionScreen;
